import actionCreatorFactory from "typescript-fsa";

const create = actionCreatorFactory("Highlighted Rows");

export const highlightRows = create<string[]>("HIGHLIGHT");
export const unhighlightRows = create("UNHIGHLIGHT");



// WEBPACK FOOTER //
// ./src/spread/model/highlightedRows/actions.ts